import React from 'react';
import ElaborateFooter from '../../../common/ElaborateFooter';
import Header from '../../../common/Header';
//import OutreachSequenceInput from './assets/OutreachSequenceInput.png';
//import OutreachSequenceOutput from './assets/OutreachSequenceOutput.png';

const OutreachSequencePage = () => {
  return (
    <>
      <Header />
      <div className="max-w-4xl mx-auto p-8 bg-white rounded-lg">
        <button className="text-indigo-800 mb-4" onClick={() => window.history.back()}>&larr; Back to templates</button>
        <h1 className="text-3xl text-indigo-800">3 Step Outreach Sequence</h1>

        <section className="mb-8 mt-8">
          <h2 className="text-2xl text-indigo-800 mb-4">Overview</h2>
          <p>Create effective 3-step outreach sequences to engage your prospects.</p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl text-indigo-800 mb-4">Key Features</h2>
          <ul className="list-disc list-inside">
            <li><strong>Structured Sequences:</strong> Predefined steps to ensure consistent outreach.</li>
            <li><strong>Customizable Messages:</strong> Tailor each step to fit your specific needs.</li>
            <li><strong>Follow-Up Automation:</strong> Automate follow-ups to save time and increase efficiency.</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl text-indigo-800 mb-4">How It Works</h2>
          <div>
            <h3 className="text-xl text-indigo-700 mb-2">1. Input Outreach Details</h3>
            {/*<img src={OutreachSequenceInput} alt="Input Outreach Details" className="mb-4" />*/}
            <h3 className="text-xl text-indigo-700 mb-2">2. Generate Outreach Sequence</h3>
            {/*<img src={OutreachSequenceOutput} alt="Generated Outreach Sequence" className="mb-4" /> */}
            <h3 className="text-xl text-indigo-700 mb-2">3. Optimize and Send</h3>
            <p>Optimize your sequence with provided tips and send them to your prospects.</p>
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl text-indigo-800 mb-4">Benefits</h2>
          <ul className="list-disc list-inside">
            <li><strong>Increased Engagement:</strong> Engage your prospects more effectively.</li>
            <li><strong>Higher Conversion Rates:</strong> Convert more prospects into leads.</li>
            <li><strong>Better ROI:</strong> Maximize your return on investment with structured outreach.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl text-indigo-800 mb-4">Use This Template</h2>
          <p className="mt-4"><a className="text-md text-indigo-800" href="https://app.graphia.ai">Sign up</a> & get started</p>
        </section>
      </div>
      <ElaborateFooter />
    </>
  );
};

export default OutreachSequencePage;
